import { jsx as _jsx } from "react/jsx-runtime";
import InspectionProfileFields from './inspection-profile-fields';
function CodeStyleFields({ settingIndex }) {
    // CodeStyleFields are the same as InspectionProfileFields
    return _jsx(InspectionProfileFields, { settingIndex: settingIndex });
}
export default CodeStyleFields;
